import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import alertModalStyles from "../../../../../Reusables/components/AlertModal/AlertModal.module.css";
import CustomButton from "../../../../../pages/reusable_components/custom_button_component/Button";
import * as Icon from "react-bootstrap-icons";
import TextInput from "../../../../../Reusables/components/TextInput/TextInput";
import SelectInput from "../../../../../Reusables/components/SelectInput/SelectInput";

const DropdownOptionsModal: React.FC<{ show: boolean; selectedFieldsList: any[]; onHide: () => void }> = ({
  show,
  selectedFieldsList,
  onHide,
}) => {
  const [selectedField, setSelectedField] = useState<any>();
  const [description, setDescription] = useState("");
  const [options, setOptions] = useState([{ id: 1, label: "" }]);

  const handleAddOption = () => {
    setOptions([...options, { id: Date.now(), label: "" }]);
  };

  const handleRemoveOption = (id: number) => {
    setOptions(options.filter((opt) => opt.id !== id));
  };

  const handleModalClose = (action: string) => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName={alertModalStyles.dialog}
      contentClassName={`${alertModalStyles.content}`}
      backdropClassName={alertModalStyles.backdrop}
      keyboard={false}
    >
      <Modal.Header closeButton className={alertModalStyles.header}>
        <Modal.Title className={alertModalStyles.message}>Mapping</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Field Name */}
          <Form.Group>
            <span className={alertModalStyles.message}>Field Name</span>
            <SelectInput
              field={{
                id: "",
                type: "text",
                options: selectedFieldsList,
                label: "",
                customLabel: "",
                value: selectedField?.value ?? "",
                width: "90%",
                placeholder: `Select field`,
                validation: [{ type: "required", message: "Required!" }],
              }}
              handleChange={(_, selected) => {
                console.log(selected)
                setSelectedField(selected)
              }
              }
              handleBlur={() => { }}
              handleSelect={() => { }}
            />
          </Form.Group>

          <br />

          {/* Description */}
          <Form.Group>
            <span className={alertModalStyles.message}>Description</span>
            <TextInput
              field={{
                id: "",
                type: "text",
                label: "",
                customLabel: "",
                value: `${description}`,
                width: "90%",
                placeholder: `Enter description`,
                validation: [{ type: "required", message: "Required!" }],
              }}
              handleChange={(_, event) => setDescription(event.target.value)
              }
              handleBlur={() => { }}
              handleSelect={() => { }}
            />
          </Form.Group>

          <br />

          {/* Dropdown Options Section */}
          <span>Dropdown Options</span>
          {options.map((opt, index) => (
            <div
              key={opt.id}
              className={alertModalStyles.optionRow}
              style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}
            >
              <TextInput
                field={{
                  id: String(index),
                  type: "text",
                  label: "",
                  customLabel: "",
                  value: "",
                  width: "90%",
                  placeholder: `Label ${index + 1}`,
                  validation: [{ type: "required", message: "Required!" }],
                }}
                handleChange={(_, event) => { }
                }
                handleBlur={() => { }}
                handleSelect={() => { }}
              />
              <Icon.DashCircleFill
                style={{
                  fontSize: 20,
                  color: "var(--theme1_primary)",
                  cursor: "pointer",
                  marginLeft: 18,
                }}
                onClick={() => handleRemoveOption(opt.id)}
              />
            </div>
          ))}

          <CustomButton content={"Add option"} type={"secondary"} onclick={handleAddOption} />
        </Form>
      </Modal.Body>

      <Modal.Footer className={alertModalStyles.footer}>
        <CustomButton content={"Cancel"} type={"quinary"} onclick={() => handleModalClose("cancel")} />
        <CustomButton content={"Save"} type={"tertiary"} onclick={() => handleModalClose("okay")} />
      </Modal.Footer>
    </Modal>
  );
};

export default DropdownOptionsModal;
